import React, { useEffect, useState } from 'react';
import { Table, Container, Spinner, Button } from 'react-bootstrap';
import axios from 'axios';

const FailedAttemptsList = () => {
  const [attempts, setAttempts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [totalPages, setTotalPages] = useState(1);
  const API_BASE = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    fetchAttempts();
  }, [page]);

  const fetchAttempts = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("admin_token");
      const res = await axios.get(`${API_BASE}/api/customers_a/failed-attempts`, {
        headers: { Authorization: `Bearer ${token}` },
        params: { page, per_page: perPage }
      });
      setAttempts(res.data.data);
      setTotalPages(res.data.pagination.total_pages);
    } catch (err) {
      console.error('Error fetching attempts:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-4">
      <h4>Failed Login Attempts</h4>
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>Username</th>
                <th>Reason</th>
                <th>IP</th>
                <th>Country</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {attempts.map((a, index) => (
                <tr key={index}>
                  <td>{(page - 1) * perPage + index + 1}</td>
                  <td>{a.username}</td>
                  <td>{a.reason}</td>
                  <td>{a.ip_address}</td>
                  <td>{a.country}</td>
                  <td>{new Date(a.attempts_date).toLocaleString()}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <div className="d-flex justify-content-between">
            <Button disabled={page <= 1} onClick={() => setPage(page - 1)}>Previous</Button>
            <span>Page {page} of {totalPages}</span>
            <Button disabled={page >= totalPages} onClick={() => setPage(page + 1)}>Next</Button>
          </div>
        </>
      )}
    </Container>
  );
};

export default FailedAttemptsList;
